import { render } from "./TextNr4.vue?vue&type=template&id=595e775f&scoped=true"
import script from "./TextNr4.vue?vue&type=script&lang=js"
export * from "./TextNr4.vue?vue&type=script&lang=js"

import "./TextNr4.vue?vue&type=style&index=0&id=595e775f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595e775f"]])

export default __exports__